import { matchPath } from 'react-router-dom';
import {
  BREADCRUMB_GROUP_TITLES,
  BREADCRUMB_SUB_PAGE_TITLES,
  DYNAMIC_BREADCRUMB_TITLES,
} from '@/constant/dynamic-breadcrumb-title';

export type HrmBreadcrumb = {
  /** Translation key of the crumb's label. */
  title: string;
  /** Where the crumb links to; the current page (the last crumb) never links. */
  href?: string;
};

const titleOf = (path: string): string | null =>
  DYNAMIC_BREADCRUMB_TITLES[path] ??
  BREADCRUMB_SUB_PAGE_TITLES.find(({ pattern }) => matchPath({ path: pattern, end: true }, path))
    ?.title ??
  null;

/**
 * The top bar's trail for `pathname`: one crumb per path prefix that is a page, e.g.
 * `/settings/organization/departments` → Settings › Departments and `/people/<id>/edit` →
 * People › Employee Details › Edit Employee. Menu group names (`/time-off`, `/settings/organization`)
 * and segments that are no page of their own (`/service-requests/noc/<id>`) are left out, as in the
 * HR Module Prototype.
 */
export const getHrmShellBreadcrumbs = (pathname: string): HrmBreadcrumb[] => {
  const segments = pathname.split('/').filter(Boolean);
  const crumbs: HrmBreadcrumb[] = [];
  segments.forEach((_, index) => {
    const path = `/${segments.slice(0, index + 1).join('/')}`;
    if (BREADCRUMB_GROUP_TITLES[path]) return;
    const title = titleOf(path);
    if (title) crumbs.push({ title, href: path });
  });
  const last = crumbs.at(-1);
  if (last) delete last.href;
  return crumbs;
};

/** Translation key of the page at `pathname` (its last crumb), e.g. for the Back button's tooltip. */
export const getPageTitle = (pathname: string): string | null =>
  getHrmShellBreadcrumbs(pathname).at(-1)?.title ?? null;
